import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import { storage } from '@/utils/storage'

Vue.use(VueI18n)

const LOCALE_KEY = 'edge_locale'

// UI locale -> backend `language` / `lang` value
export const API_LANG = { zh: 'cn', en: 'en' }

export const i18n = new VueI18n({
  locale: storage.get(LOCALE_KEY) || 'zh',
  fallbackLocale: 'zh',
  messages: { zh, en }
})

export function setLocale (locale) {
  i18n.locale = locale
  storage.set(LOCALE_KEY, locale)
  document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en'
}

export function apiLang () {
  return API_LANG[i18n.locale] || 'en'
}

export function roundName (n) {
  const key = `round.names[${n}]`
  return n > 0 && i18n.te(key) ? i18n.t(key) : i18n.t('round.n', { n })
}

// Map backend error codes/messages to readable text; fall back to the raw message.
export function errorText (err) {
  const msg = err && err.message
  // vue-i18n treats "." as a path separator, so drop trailing dots before lookup
  const key = msg && String(msg).replace(/\.+$/, '')
  if (key && i18n.te(`error.${key}`)) return i18n.t(`error.${key}`)
  return msg || i18n.t('error.REQUEST_FAILED')
}
